import { Action, createReducer, on } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { InstalledView } from 'src/app/model/device';

import * as DeviceListActions from './device-list.actions';

export interface State {
    loading: boolean;
    installedViews: InstalledView[];
    paging?: ItemsPagination;
}

const initialState: State = {
    loading: false,
    installedViews: [],
};

const deviceListReducer = createReducer(
    initialState,
    on(DeviceListActions.getInstalledViews, (state) => ({ ...state, loading: true })),
    on(DeviceListActions.getInstalledViewsSuccess, (state, payload) => ({
        ...state,
        installedViews: payload.installedViews,
        paging: payload.paging,
        loading: false
    })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceListReducer(state, action);

